import { Viewport } from "../pixel-accessor";
import type { ReversePixelMapperResolver } from "./ReversePixelMapperResolver";
import type {
  GetReversePixelMapperFactoryArgs,
  ReversePixelMapperFactoriesPool,
  ReversePixelMapperFactoriesPoolKeyMap,
} from "./ReversePixelMapperFactoriesPool";
import type { ReversePixelMapper } from "./ReversePixelMapper";

/**
 * Base implementation of ReversePixelMapperResolver interface.
 */
export class BaseReversePixelMapperResolver
  implements ReversePixelMapperResolver
{
  /**
   * BaseReversePixelMapperResolver constructor.
   *
   * @param reversePixelMapperFactoriesPool
   */
  constructor(
    private readonly reversePixelMapperFactoriesPool: ReversePixelMapperFactoriesPool
  ) {}

  /**
   * @inheritDoc
   */
  resolve<K extends keyof ReversePixelMapperFactoriesPoolKeyMap | string>(
    name: K,
    args: GetReversePixelMapperFactoryArgs<K>,
    viewport: Viewport
  ): K extends keyof ReversePixelMapperFactoriesPoolKeyMap
    ? ReturnType<ReversePixelMapperFactoriesPoolKeyMap[K]["create"]>
    : ReversePixelMapper {
    const factory = this.reversePixelMapperFactoriesPool.get(name);
    return factory.create(
      args,
      viewport
    ) as K extends keyof ReversePixelMapperFactoriesPoolKeyMap
      ? ReturnType<ReversePixelMapperFactoriesPoolKeyMap[K]["create"]>
      : ReversePixelMapper;
  }
}
